import { Component, Injector, ViewEncapsulation, OnInit, Input } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';

import * as _ from 'lodash-es';

import { AppConsts } from "@shared/AppConsts";

@Component({
    selector: 'app-image-container',
    templateUrl: './image-container.component.html',
    styleUrls: ['./image-container.component.less'],
    encapsulation: ViewEncapsulation.None,
})
export class ImageContainerComponent extends AppComponentBase implements OnInit {
   
    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    //#region Props

    @Input() articleId: string;
    @Input() height: number = 38;
    
    //#endregion
    
    //currentSkillElement: any;
    //private calloutRef: ComponentRef<ImageHightlighterTooltipComponent>;

    //@ViewChild(PopupHostDirective)
    //private popupHost: PopupHostDirective;

    constructor(
        injector: Injector,
        //private componentFactoryResolver: ComponentFactoryResolver
    ) {
        super(injector);
    }

    ngOnInit(): void {

    }

    getImgUrl() {
        //return `${this.remoteServiceBaseUrl}/WebShop/GetArticleImage?articleId=${articleId}&tenantId=${this.appSession.tenant.id}`;
        return `${this.remoteServiceBaseUrl}/WebShop/${this.appSession.tenant.id}/GetArticleImage/${this.articleId}.jpg`;
    }


    //// popup methods 
    ///** https://stackblitz.com/edit/angular-khoagq?file=src%2Fapp%2Fapp.component.ts || https://stackblitz.com/edit/angular-e9py6n?file=src%2Fapp%2Ftooltip%2Ftooltip.component.ts
    //* DYNAMIC POPUP METHODS
    //*/
    //onSkillMouseEnter(event, skill) {
    //    this.currentSkillElement = event.target;
    //    const currentPosition = this.offset(event.target);
    //    this.showCallout(skill, currentPosition);

    //}

    //@HostListener('mouseover', ['$event'])
    //onSkillMouseOver(event) {
    //    let hoverComponent = event.target;
    //    let inside = false;
    //    do {
    //        if (this.calloutRef) {
    //            if (hoverComponent === this.calloutRef.location.nativeElement || hoverComponent === this.currentSkillElement) {
    //                inside = true;
    //            }
    //        }
    //        hoverComponent = hoverComponent.parentNode;
    //    } while (hoverComponent);
    //    if (inside) {
    //        console.log('inside');
    //    } else {
    //        console.log('outside');
    //        this.hideCallout();
    //    }
    //}
    //private createCallout(data: any): ComponentRef<ImageHightlighterTooltipComponent> {
    //    const viewContainer = this.popupHost.viewContainerRef;
    //    viewContainer.clear();
    //    const calloutComponentFactory = this.componentFactoryResolver.resolveComponentFactory(ImageHightlighterTooltipComponent);
    //    const calloutComponentRef = viewContainer.createComponent(calloutComponentFactory);
    //    calloutComponentRef.instance.data = data;
    //    return calloutComponentRef;
    //}
    //showCallout(skill, currentPosition) {
    //    this.calloutRef = this.createCallout(skill);
    //    this.calloutRef.instance.styleLeft = currentPosition.left + 'px';
    //    this.calloutRef.instance.styleTop = currentPosition.top + 27 + 'px';
    //}
    //hideCallout() {
    //    if (this.calloutRef) {
    //        this.calloutRef.destroy();
    //        this.calloutRef = null;
    //    }
    //}
    //// calculate position relative to document for proper popup displaying
    //private offset(el) {
    //    const rect = el.getBoundingClientRect();
    //    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    //    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    //}
    
}
